import classNames from "classnames";

import gdprCSS from "./Gdpr.module.css";

function Gdpr() {
  return (
    <div className={classNames("u-flex", "u-flex-column", "u-bg-background", gdprCSS.backImg)}>
      <div className="u-flex u-flex-column u-flex-content-center u-ml15per u-mr15per">
        <h1 className="u-t-primary u-t-w700 u-t-halign-c u-m0 u-mt80px">PRIVOLA ZA OBRADU OSOBNIH PODATAKA –</h1>
        <h1 className="u-t-primary u-t-w700 u-t-halign-c">RADI PRIMITKA ODGOVORA NA UPIT ILI PRIMITKA PONUDE KROZ INFO TOTEM I KALKULATOR</h1>
      </div>
      <div className="u-ml15per u-mr15per mobile-margin">
        {/* <h3 className="u-t-primary u-t-w400">Zaštita osobnih podataka</h3> */}
        <p className="u-t-black u-t-w400">
          Kao korisnik / korisnica KNAUF Internet usluga Info totema koji se nalazi na domeni{" "}
          <a className="u-t-primary u-t-w400 u-cursor-pointer" href="www.knauf.hr/Totem">
            www.knauf.hr/Totem
          </a>{" "}
          ili Kalkulatora koji se nalazi na domeni{" "}
          <a className="u-t-primary u-t-w400 u-cursor-pointer" href="https://kalkulator.knauf.hr/pocetna">
            https://kalkulator.knauf.hr/pocetna
          </a>{" "}
          ovime izjavljujem da sam suglasan / suglasna da društvo KNAUF d.o.o., OIB: 46419854204, Uzdolje polje 91, Uzdolje polje, 22300 Knin, kao Voditelj
          obrade koristi moje osobne podatke: ime, prezime, naziv obrta, tvrtku, tvrtku trgovačkog društva, pravni oblik trgovačkog društva, OIB, adresu, broj
          telefona, e-mail sa svrhom da kroz uslugu Info totem od društva KNAUF dobijem odgovore i pojašnjenja na pojedina tehnička i izvedbena pitanja ili da
          kroz uslugu Kalkulator dobijem ponudu cijene materijala prema predviđenoj količini utroška materijala dobivenoj korištenjem kalkulatora.
        </p>
        <p className="u-t-black u-t-w400">Društvo Knauf d.o.o. osobne podatke koristit će isključivo u gore navedene svrhe.</p>
        <p className="u-t-black u-t-w400">
          Klikom na polje „Dajem privolu za obradu osobnih podataka“ korisnik daje pristanak i suglasnost da se prikupljeni podaci mogu dostaviti ovlaštenim
          trećim osobama, partnerima društva Knauf, u gore navedenu svrhu dobivanja ponude cijene materijala prema predviđenoj količini utroška materijala
          dobivenoj korištenjem kalkulatora.
        </p>
        <p className="u-t-black u-t-w400">
          Podaci kontakt osobe za zaštitu podataka: Knauf d.o.o., e-mail:{" "}
          <a className="u-t-primary u-t-w400 u-cursor-pointer" href="mailto:upiti-hr@knauf.com">
            upiti-hr@knauf.com.
          </a>
        </p>
        <p className="u-t-black u-t-w400">
          Pravo na pristup, brisanje osobnih podataka, ulaganje prigovora, zahtjeva na ograničavanje obrade, prijenosa podataka i povlačenje privole na obradu
          osobnih podataka moguće je ostvariti slanjem e-maila na:{" "}
          <a className="u-t-primary u-t-w400 u-cursor-pointer" href="mailto:upiti-hr@knauf.com">
            upiti-hr@knauf.com.
          </a>{" "}
          Svoj pristanak na obradu osobnih podataka možete povući u bilo kojem trenutku.
        </p>
        <p className="u-t-black u-t-w400 u-mb80px">
          Prikupljeni osobni podaci kroz usluge Info totem ili Kalkulator neće biti javno objavljeni, a sačuvat ćemo ih na vrijeme do tri godine za slučaj
          eventualnih reklamacija i / ili sudskih sporova nakon čega će isti biti izbrisani bez ikakve daljnje odgode. U slučaju korisnikovog opoziva privole
          prikupljeni osobni podaci bit će izbrisani odmah, bez ikakve daljnje odgode i prije isteka navedenog roka. Ispitanik u slučaju opravdane sumnje da
          obrada osobnih podataka nije izvršena transparentno ima pravo podnošenja prigovora Agenciji na zaštitu osobnih podataka.
        </p>
      </div>
    </div>
  );
}
export default Gdpr;
